/* global DPI_STATS_TMOUT_MS */
import React, { useContext } from "react";
import Report from "views/Statistics/Report/TotalVolume/component";
import ActionsContext from "common/ActionsContext";
import DPITotalVolumeHelpModal from "./Help";
import CategoryDetailsModal from "../CategoryDetails";
import { expressTarget, getBqnIdCmdPart } from "common/api";
import { parseVolumesAddTotals } from "../api";
import * as d3 from "d3";
import useProfile from "common/hooks/useProfile";
import View from "common/View";
import { hoursScopeChoices, periodAsHours } from "common/constants";

const wholeInterval = (hours, base=60) =>
  hours * base;

const doSpeedTotalsRetrieval = (
  target,
  hours = 72,
  categories = 20,
  directions = "all",
  filter = "all",
  mode,
  bqnId
) => 
  expressTarget(target).then((expressedTarget) =>
    ifCl.run(
      `show statistics dpi volume ${expressedTarget} hours ${
        hours} interval ${wholeInterval(hours)} categories ${
        categories - 1
      } direction ${directions} ${filter === "auto" ? "udrs-auto" : ""}${getBqnIdCmdPart(mode, bqnId)}`,
      { timeout: DPI_STATS_TMOUT_MS }
    )
  );

const retrieval = ({ target, hours, categories, directions, filter, mode, bqnId }) =>
  doSpeedTotalsRetrieval(target, hours, categories, directions, filter, mode, bqnId)
    .then(parseVolumesAddTotals)
    .then((totals) => ({
      totals,
    }))
    .catch((error) => console.error(error) || error);

const formatThousandsAndDecimals = d3.format(",.2f");

const formatDecimals = (value) =>
  value === undefined ? "--" : formatThousandsAndDecimals(value);

const TotalVolumeVsDPI = ({ total, dpi }) => {
  return (
    <h4 className="align-left">
      Total volume: {formatDecimals(total)} GB - DPI sample:{" "}
      {formatDecimals(dpi)} GB
    </h4>
  );
};

const enabled = (dpiPerUserEnabled) => ({
  policyType: false,
  hours: true,
  directions: true,
  categories: true,
  filter: true,
  target: dpiPerUserEnabled === true,
  output: false,
  volumeOrRatio: false,
});

const customSettings = {
  hours: { options: hoursScopeChoices },
};

const DPITotalVolume = () => {
  const profile = useProfile() || {};
  const areClientsInspectable = profile.dpiEnabled === true;
  const targetLabel = areClientsInspectable
    ? "main clients and servers"
    : "main servers";
  const targetTooltip = `Click to see ${targetLabel}`;
  const actions = useContext(ActionsContext);
  const Help = () =>
    <DPITotalVolumeHelpModal targetLabel={targetLabel} />
  return (
    <View title="DPI volume statistics"
      subtitle={`Click on the area in the pie-chart for each service to see main ${targetLabel}`}
      Help={Help}>
      <Report
        graphTitle={null}
        itemsValueFrom="volume"
        valueIsShare={false}
        provider={retrieval}
        settings={customSettings}
        actions={actions}
        Totals={TotalVolumeVsDPI}
        enabled={enabled(areClientsInspectable)}
        targetTooltip={targetTooltip}
      />
      <CategoryDetailsModal sourceView="viewDPITotalVolume" />
    </View>);
};

export default DPITotalVolume;
